<template lang="pug">
  div
    h6 待補充清單
      small （尚未列入為補藥規劃）
    form.form-inline(@submit.prevent="onFilterSet")
      select.form-control.mr-2(v-model="systemId")
        option(:value="undefined") 選擇系統
        option(v-for="sys in systems" :value="sys.id") {{ sys.name }}
      button.btn.btn-primary(type="submit") 搜尋
    hr
    vuetable(ref="vuetable"
    pagination-path=""
    :fields="fields"
    :api-mode="false"
    :css="boostrapCss"
    :append-params="moreParams"
    :http-options="httpOptions"
    @vuetable:cell-clicked="onCellClicked")
      template(slot="num-refill" slot-scope="props")
        span(style="color: red") {{ props.rowData.max_stock - props.rowData.stock }}
    button.btn.btn-primary(@click="setRefill") 設定補藥項目
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import Vue from 'vue';
import { mapState } from 'vuex';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import readCookie from '@/vuex/functions/readCookie';
import server from '@/config';


export default {
  name: 'ADCPlanning',
  data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
      },
      httpOptions: {
        headers: {
          Authorization: `Token ${readCookie('Token')}`,
        },
      },
      server,
      fields: [
        {
          name: '__checkbox',
        },
        {
          name: 'device',
          title: '位置',
          callback: 'readablePosistion',
        },
        {
          name: 'medication.code',
          title: '藥碼',
        },
        {
          name: 'medication.CGMH_number',
          title: '料位號',
        },
        {
          name: 'medication.generic_name',
          title: '學名',
        },
        {
          name: 'patch_number',
          title: '批號',
        },
        {
          name: 'expired_date',
          title: '有效期限',
        },
        {
          name: 'stock',
          title: '存量',
        },
        {
          name: 'max_stock',
          title: '最大存量',
        },
        {
          name: '__slot:num-refill',
          title: '待補數量',
        },
      ],
      moreParams: {},
      systemId: undefined,
      systems: [],
    };
  },
  components: {
    Vuetable,
  },
  async mounted() {
    await this.getSystem();
    await this.getRefillData();
  },
  methods: {
    getSystem() {
      return this.instance.get('/api/system/', {
        params: {
          type: 'ADC',
        },
      })
      .then((res) => {
        this.systems = res.data.results;
        console.log(this.systems);
      });
    },
    onFilterSet() {
      this.getRefillData();
    },
    getRefillData(systemId) {
      const filteredData = [];
      this.instance.get(`${server}/api/drug-storage-not-full/`, {
        params: {
          device__net__system: this.systemId,
        },
      })
      .then((res) => {
        res.data.forEach((item) => {
          const theExpiredDate = moment(item.expired_date);
          const todayDate = moment();
          const remainExpiredDays = theExpiredDate.diff(todayDate, 'days');
          if (remainExpiredDays >= 0) {
            filteredData.push(item);
          }
        });
        this.$refs.vuetable.setData(filteredData);
      });
    },
    onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    setRefill() {
      const selected = this.$refs.vuetable.selectedTo;
      if (selected.length !== 0) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '新增補藥規劃中...',
          confirm: false,
        });
        const promises = [];
        selected.forEach((drugStorageId) => {
          promises.push(this.instance.post('/api/refill-order/', {
            drug_storage_id: drugStorageId,
          }));
        });

        axios.all(promises)
        .then((res) => {
          console.log(res);
          this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '新增完成',
            confirm: true,
          });
          this.$refs.vuetable.selectedTo = [];
          this.getRefillData();
        });
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請至少選擇一項藥物',
          confirm: true,
        });
      }
    },
    readablePosistion(val) {
      let pos = `${val.net.system.name}-${val.net.open_times}藥櫃-${val.net.row_id}層`;
      if (val.pos_row !== 0) {
        pos = `${pos}-${val.pos_row}列-${val.relative_col}行`;
      }
      return pos;
    },
  },
  computed: mapState({
    instance: state => state.instance,
    drugStorageChangedTime: state => state.drugInDevice.drugStorageChangedTime,
  }),
  watch: {
    drugStorageChangedTime() {
      this.getRefillData();
    },
  },
};
</script>




// WEBPACK FOOTER //
// Planning.vue?42bb8f9c